import type { PropsWithChildren } from 'react';
import { useSettings } from '@wu/widget-core';
import { useNewUserTimeStorage } from '../helpers';

export const FilterUser = ({ children }: PropsWithChildren) => {
  const { showChatTo, editMode } = useSettings();
  const currentTime = new Date();
  const [_, { get, set }] = useNewUserTimeStorage();
  const cachedTime = get();
  const isRemember =
    new Date(cachedTime || '').getTime() / 1000 + 86400 >
    currentTime.getTime() / 1000;
  const showChat =
    (showChatTo === 'newVisitors' && !isRemember) ||
    (showChatTo === 'returningVisitors' && isRemember) ||
    showChatTo === 'allVisitors' ||
    !showChatTo;

  window.addEventListener('beforeunload', () => {
    if (!cachedTime && !editMode) {
      set(currentTime.getTime());
    }
  });

  if (editMode || showChat) {
    return children;
  }

  return null;
};
